export { ASSETS } from '_/constants/assets-paths'
export { ENVS } from '_/constants/envs'
export { MEDIA_QUERIES } from '_/constants/media-queries'
export { VIEW } from '_/constants/view'

export const CONST = {
	PRODUCTION: 'production',
	SERVER: 'server',
	CLIENT: 'client',
	UNKNOWN: 'unknown',
} as const

export const PROTECTED_ROUTES = {
	DASHBOARD: '/dashboard',
	FLASHCARDS: '/flashcards',
	ENTRY: '/flashcards',
}

export const LOCAL_HREFS = {
	HOME: '/',
}

export const AUTH_ROUTES = {
	LOGIN: '/login',
	REGISTER: '/register',
	FORGOT_PASSWORD: '/forgot-password',
	AUTH: '/auth',
} as const

export const PUBLIC_HREFS = {
	...AUTH_ROUTES,
	HOME: '/',
	LEGAL_NOTICE: '/legal-notice',
	PRIVACY_POLICY: '/privacy-policy',
}

export const LOCAL_STORE_NAME = 'nina_store'
